# затенение контента
class window.ShadingContent
  constructor: ->
    @shadowActiveFlag = false # флаг, показывающий наличие затенения
    @shadingBlock = $('.shading-block') # полупрозрачный блок с маской, для затенения контента
    @shadingBlockActive = 'shading-block--active' # класс для активации затенения
    @shadingContentActive = 'shading-block--content-active' # класс для активации контента, который не затеняется
    @shadingDisableTimeout = undefined # таймаут для отмены затенения

    
    
  # активация затенения
  shadingActive: (activeContentSelectors)->
    if $(window).innerWidth() > 1070
      self = this
      @shadowActiveFlag = true
      @shadingBlock.addClass(@shadingBlockActive)

      # вешаем класс активности на блоки, которые не должны быть затенены
      activeContentSelectors.forEach (itemSelector)->
        self.shadingContentActivate(itemSelector)

        
  # отмена затенения
  shadingDisable: (activeContentSelectors, activeContentTimeout = 300)->
    if $(window).innerWidth() > 1070
      self = this
      @shadowActiveFlag = false

      activeContentSelectors.forEach (itemSelector)->
        $(itemSelector).attr('data-active', false)

      # таймаут нужен, что бы не прагало затенении при переводе мышки между близко расположенными элементами, активизирующие затенение
      @shadingDisableTimeout = setTimeout(
        ->
          unless self.shadowActiveFlag
            self.shadingBlock.removeClass(self.shadingBlockActive)

          # таймаут для того, что бы активный контент не скрывался затеняющей маской до того, как маска исчезнет полностью
          setTimeout(
            ->
              activeContentSelectors.forEach (itemSelector)->
                unless $(itemSelector).attr('data-active') == 'true'
                  self.shadingContentDisable(itemSelector)
          , activeContentTimeout)
      , 100)

    
  
  # активация контента, который не должен затенятся
  shadingContentActivate: (activeContentSelectors)->
    self = this
    $(activeContentSelectors).addClass(self.shadingContentActive)
    $(activeContentSelectors).attr('data-active', true)

  # отмена активности для контента
  shadingContentDisable: (activeContentSelectors)->
    self = this
    $(activeContentSelectors).removeClass(self.shadingContentActive)


// WEBPACK FOOTER //
// ./assets/javascripts/app/shading_content.coffee